/* eslint-disable */
import React, { useEffect, useState, useCallback } from 'react';
import { Button, Card, Header,  } from 'semantic-ui-react';

const ProductPlans = ({ plans, updateZonePlan }) => {
    const [groupedPlans, setGroupedPlans] = useState([]);

    useEffect(() => {
        const grouped = {};
        plans.forEach(plan => {
            if (!grouped[plan.name]) {
                grouped[plan.name] = { name: plan.name, plans: [] };
            }
            grouped[plan.name].plans.push(plan);
        });
        setGroupedPlans(Object.values(grouped));
    }, [plans]);

    const handleSelectPlan = useCallback((planName) => {
        updateZonePlan(planName);
    }, [updateZonePlan]);

    return (
        <div style={{marginTop:'30px',paddingBottom:'50px'}}  className="ui container">
            <div className="ui stackable three column grid">
                {groupedPlans.map(groupedPlan => {
                    const monthlyPlan = groupedPlan.plans.find(p => p.interval === 'monthly');
                    const annualPlan = groupedPlan.plans.find(p => p.interval === 'annual');

                    // Determine the best price to display
                    let bestPrice = '';
                     if (monthlyPlan && annualPlan) {
                        bestPrice = `$${monthlyPlan.unitPrice} / month, $${annualPlan.unitPrice} / year`;
                    } else if (monthlyPlan) {
                        bestPrice = `$${monthlyPlan.unitPrice} / month`;
                    } else if (annualPlan) {
                         bestPrice = `$${annualPlan.unitPrice} / year`;
                    }


                    return (
                        <div className="column" key={groupedPlan.name}>
                            <Card className="raised">
                                <Card.Header style={{ color: 'black', padding:'20px', fontSize: '2.5em', fontWeight: 'bold' }}>
                                    {groupedPlan.name}
                                </Card.Header>
                                <Card.Description style={{margin:'10px',height:'300px'}} className="text-gray-400">
                                    {monthlyPlan?.description || annualPlan?.description || 'Description not available.'}
                                </Card.Description>
                                <Card.Content>
                                    <div className="text-2xl font-bold text-blue-400 mb-4">{bestPrice}</div>
                                    <Button
                                        primary
                                        onClick={() => handleSelectPlan(groupedPlan.name)}

                                    >
                                        Select
                                    </Button>
                                </Card.Content>
                            </Card>
                        </div>
                    );
                })}
            </div>
        </div>
    );
};

export default ProductPlans;
// /* eslint-disable */
// import React, { useEffect, useState, useCallback } from 'react';

// const ProductPlans = ({plans,updateZonePlan}) =>{
    
//     useEffect(()=>{
//         console.log(plans)
//     },[])

//     return (
//         <div>
//             Display product plans here.
//         </div>
//     )
// }

// export default ProductPlans;